import * as RadixSelect from '@radix-ui/react-select'
import { FC } from 'react'
import { SelectContext, Variant } from './SelectContext'

export interface Props extends RadixSelect.SelectProps {
  variant?: Variant
  value: string
}

export const Select: FC<Props> = ({ children, variant, value, ...props }) => {
  return (
    <SelectContext.Provider value={{ variant, value }}>
      <RadixSelect.Root value={value} {...props}>
        {children}
      </RadixSelect.Root>
    </SelectContext.Provider>
  )
}
